/**
 * Per-message route-aware context for the AI chat: where the clinician is
 * (ambient route params) plus who's asking (acting practitioner). Sent fresh
 * with every message; never persisted. The backend pins the subject patient
 * write-once and treats the rest as ambient.
 */
export interface ChatRouteContext {
  patientId?: string;
  caseId?: string;
  carePlanId?: string;
  visitId?: string;
  practitionerId?: string;
}

const ROUTE_PARAM_KEYS = ["patientId", "caseId", "carePlanId", "visitId"] as const;

export function buildChatContext(
  params: Record<string, string | undefined>,
  practitionerId: string | undefined,
): ChatRouteContext {
  const ctx: ChatRouteContext = {};
  for (const key of ROUTE_PARAM_KEYS) {
    const value = params[key];
    if (value) ctx[key] = value;
  }
  if (practitionerId) ctx.practitionerId = practitionerId;
  return ctx;
}
